import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const GlobeAmericasIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/globe-americas"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M21.6 12.0004C21.6 17.3023 17.302 21.6004 12 21.6004C6.69809 21.6004 2.40002 17.3023 2.40002 12.0004C2.40002 6.69846 6.69809 2.40039 12 2.40039C17.302 2.40039 21.6 6.69846 21.6 12.0004ZM19.8 12.0004C19.8 16.3082 16.3078 19.8004 12 19.8004C7.6922 19.8004 4.20002 16.3082 4.20002 12.0004C4.20002 9.78836 5.12082 7.79139 6.60003 6.37188V6.90922C6.60003 8.02313 7.04252 9.09142 7.83018 9.87907L9.9515 12.0004L9.60003 12.3519C9.13139 12.8205 9.1314 13.5803 9.60002 14.0489L10.8728 15.3217C11.2104 15.6593 11.4 16.1171 11.4 16.5945V17.0296C11.4 17.4841 11.6568 17.8996 12.0634 18.1029L12.395 18.2687C12.9878 18.5651 13.7086 18.3248 14.005 17.7321L15.7499 14.2423C16.0964 13.5493 15.9606 12.7124 15.4127 12.1645L14.4865 11.2383C14.1651 10.9169 13.6897 10.8047 13.2585 10.9484L12.7976 11.1021C12.5144 11.1965 12.2048 11.0683 12.0712 10.8012L11.7162 10.091C11.605 9.86877 11.6486 9.60035 11.8243 9.42466C12 9.24896 12.2684 9.2054 12.4906 9.31652L12.805 9.4737C12.9716 9.55702 13.1554 9.60039 13.3417 9.60039H13.5676C14.3866 9.60039 14.965 8.79796 14.706 8.02092L14.6244 7.77613C14.5472 7.5447 14.6179 7.2896 14.8031 7.13084L16.5305 5.65024C18.5098 7.06492 19.8 9.38198 19.8 12.0004Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default GlobeAmericasIcon;